export type PolygonShape =
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12"
    | "13"
    | "14"
    | "15"
    | "16"
    | "17"
    | "18"
    | "19";

export interface PolygonOptions {
    color?: string;
    gradient?: boolean;
    shape: PolygonShape;
    container?: HTMLElement;
    prepend?: boolean;
    shadow?: boolean;
    shadowColor?: string;
    shadowAngle?: number;
    shadowDistance?: number;
    background?: boolean;
}

export type PolygonShapeValue = [number, number, number, number];

export class Polygon {

    public readonly element: HTMLDivElement;
    public readonly foreground: HTMLDivElement;
    public readonly background: HTMLDivElement;
    public readonly shadow?: HTMLDivElement;

    public static TOTAL_SHAPES: number = 19;

    private _options: PolygonOptions;

    private static _shapes: PolygonShapeValue[] = [
        [0, 42, 0, 42],//1
        [42, 0, 0, 42],//2
        [42, 0, 42, 0],//3
        [0, 42, 42, 0],//4
        [21, 0, 0, 21],//5
        [0, 21, 21, 0],//6
        [0, 21, 0, 21],//7
        [21, 0, 21, 0],//8
        [74, 0, 0, 74],//9
    ];

    constructor(options: PolygonOptions) {

        options = e5.object.merge({
            prepend: true,
            shadow: false,
            gradient: false,
            shadowAngle: 135,
            shadowDistance: 20,
            background: false
        } as PolygonOptions, options);
        this._options = options;

        this.element = document.createElement("div");
        this.element.className = `polygon`;
        this.element.innerHTML = `
        ${options.shadow ? `<div class="polygon__shadow polygon__shape" data-shape="${options.shape}"></div>` : ""}
        ${options.background ? `<div class="polygon__background polygon__shape" data-shape="${options.shape}"></div>` : ""}
        <div class="polygon__foreground polygon__shape" data-shape="${options.shape}"></div>
        `;

        // var shape = Polygon._shapes[parseInt(options.shape) - 1];
        // this.element.querySelectorAll<HTMLElement>(".polygon__shape")
        //     .forEach((e) => {
        //         var top = Math.max(shape[0], shape[1]);
        //         var bottom = Math.max(shape[2], shape[3]);
        //         e.style.top = -top + "px";
        //         e.style.bottom = -bottom + "px";
        //         e.style.clipPath = `polygon(
        //             0 ${top - shape[0]}px,
        //             100% ${top - shape[1]}px,
        //             100% calc(100% - ${bottom - shape[2]}px),
        //             0 calc(100% - ${bottom - shape[3]}px)
        //         )`;
        //     });

        this.background = this.element.querySelector(".polygon__background");

        this.foreground = this.element.querySelector(".polygon__foreground");
        if (options.color) {
            this.foreground.style.backgroundColor = options.color;
        }

        if (options.gradient) {
            this.foreground.classList.add("polygon__shape--gradient");
        }

        if (options.shadow) {
            this.shadow = this.element.querySelector(".polygon__shadow");
            const pt = e5.Point.polar(options.shadowAngle, Math.abs(options.shadowDistance));
            this.shadow.style.transform = `translate(${pt.x}px, ${pt.y}px)`;
            // this.shadow.style.margin = `${pt.y}px 0 0 ${pt.x}px`;
            if (options.shadowColor) {
                this.shadow.style.backgroundColor = options.shadowColor;
            }
        }

        if (options.container) {
            if (options.prepend) {
                options.container.prepend(this.element);
            } else {
                options.container.append(this.element);
            }
        }
    }

    public get shape(): PolygonShape {
        return this._options.shape;
    }

    public set shape(value: PolygonShape) {
        if (this._options.shape == value) {
            return;
        }
        this._options.shape = value;
        this.element.querySelectorAll(".polygon__shape").forEach((e) => {
            e.setAttribute("data-shape", value);
        });
    }
}